<template>
	<div>
		<v-data-table
			v-if="hasItens"
			v-model="itensSelecionados"
			:headers="colunas"
			:items="itens"
			item-key="id"
			hide-default-footer
			:server-items-length="totalItens"
			:show-select="showSelect"
			checkbox-color="primary"
			:single-select="checkBoxDisabled"
			:options="paginacaoInterna"
			class="arp-listview mt-5 row-pointer"
		>
			<template #item="{ item, isSelected, select }">
				<tr @click="emitirEventoLinhaClicada(item)" :class="itemClass(item)">
					<td v-if="showSelect">
						<v-simple-checkbox
							id="caixaDeSelecaoEntidadeItens"
							class="row-checkbox"
							color="primary"
							:value="isSelected"
							@input="lidarComSelect(select, item, $event)"
							@click.stop
							:disabled="checkBoxDisabled"
						></v-simple-checkbox>
					</td>
					<td v-for="header in colunas" :key="header.value">
						<template v-if="showActions && header.value === 'actions'">
							<slot name="actions" :item="item"></slot>
						</template>
						<template v-if="customColumns && customColumns.some((column) => header.value === column)">
							<slot :name="header.value" :item="item"></slot>
						</template>
						<texto-tooltip
							v-else
							:key="header.value"
							:texto="getTextoFormatado(item[header.value])"
							:tamanho-maximo="tamanhoMaximoColunas[header.value]"
						></texto-tooltip>
					</td>
				</tr>
			</template>
		</v-data-table>

		<template-listagem-vazia
			:total-itens="totalItens"
			:textos="textosDoTemplateDaListagemVazia"
			:class="listagemVaziaCustomClass"
		>
			<template #acoes v-if="listagemVaziaCustom">
				<slot name="acoes-listagem-vazia"></slot>
			</template>
		</template-listagem-vazia>

		<paginacao-tabela
			v-if="showPaginacao && totalItens > 0"
			:page.sync="paginacaoInterna.page"
			:rows-per-page.sync="paginacaoInterna.rowsPerPage"
			:totalPaginas="totalPaginas"
			:totalItens="totalItens"
			@resetar-page="$emit('resetar-page')"
		></paginacao-tabela>
	</div>
</template>
<script>
import tabelaMixin from '@/views/mixins/tabela'
import PaginacaoTabela from '@/views/components/PaginacaoTabela'
import TemplateListagemVazia from '@/views/components/TemplateListagemVazia'
import TextoTooltip from '@/views/components/TextoTooltip'

export default {
	name: 'listagem-itens',
	components: { TextoTooltip, TemplateListagemVazia, PaginacaoTabela },
	mixins: [tabelaMixin],
	props: {
		itens: {
			type: Array,
			required: true,
		},
		colunas: {
			type: Array,
			required: true,
		},
		textosDoTemplateDaListagemVazia: {
			type: Object,
			required: true,
		},
		tamanhoMaximoColunas: {
			type: Object,
			default: () => ({}),
		},
		showSelect: {
			type: Boolean,
			default: () => false,
		},
		showActions: {
			type: Boolean,
			default: () => false,
		},
		showPaginacao: {
			type: Boolean,
			default: () => true,
		},
		listagemVaziaCustom: {
			type: Boolean,
			default: () => false,
		},
		listagemVaziaCustomClass: {
			type: String,
			default: () => '',
		},
		customColumns: {
			type: Array,
			default: () => [],
		},
		temItensJaSelecionados: {
			type: Boolean,
			default: () => false,
		},
		checkBoxDisabled: {
			type: Boolean,
			default: () => false,
		},
		itemClass: {
			type: Function,
			default: () => () => '',
		},
	},
	data() {
		return {
			paginacaoInterna: this.paginacao,
			itensSelecionados: [],
			itensDeselecionados: [],
		}
	},
	computed: {
		hasItens() {
			return this.itens.length > 0
		},
	},
	watch: {
		itens() {
			if (!this.temItensJaSelecionados) return

			this.itens.forEach((item) => {
				if (this.existeItemNoArray(this.itensDeselecionados, item)) item.isSelecionado = false

				if (item.isSelecionado && this.naoExisteItemNoArray(this.itensSelecionados, item)) {
					this.itensSelecionados.push(item)
				}
			})
		},
		itensSelecionados(novo) {
			this.$emit('update:quantidade-itens-selecionados', novo.length)
			this.$emit('update:itens-selecionados', novo)
		},
	},
	methods: {
		lidarComSelect(funcaoCallback, item, isSelected) {
			if (!isSelected) {
				this.itensDeselecionados.push(item)
			} else {
				this.itensDeselecionados = this.itensDeselecionados.filter(
					(deselecionado) => deselecionado.id !== item.id,
				)
			}

			funcaoCallback(isSelected)
		},
		existeItemNoArray(array, item) {
			return array.some((itemArray) => itemArray.id === item.id)
		},
		naoExisteItemNoArray(array, item) {
			return !this.existeItemNoArray(array, item)
		},
		emitirEventoLinhaClicada(item) {
			this.$emit('linha-clicada', item)
		},
		getTextoFormatado(valor) {
			return isNaN(valor) ? valor : valor.toString()
		},
	},
}
</script>
